import React from 'react';
import { PlmContractDetailForm } from './plmContract-detail-form';
import { useInjectableComponents } from '../../../system/services/injectableComponentsManager';
import { useIsSmallScreen } from '../../../system/SystemMediaQueriesProvider';

export const PlmContractAdd = () => {
  const { setTitle, setTitlePath } = useInjectableComponents();
  const isSmall = useIsSmallScreen();

  React.useEffect(() => {
    setTitle(
      isSmall ? 'Add PLM Contract' : 'Create Peak Load Management Contract',
    );
    setTitlePath('/plmContracts');

    return () => {
      setTitle(undefined);
      setTitlePath(undefined);
    };
  }, [setTitle, setTitlePath, isSmall]);

  return <PlmContractDetailForm />;
};
